module.exports = __webpack_public_path__ + "static/media/heartipro-carrying-case-4.258ca649.png";